var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImportarAgendamentoTarefas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.337,
    height: 49.172,
    viewBox: "0 0 39.337 49.172",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_124",
    "data-name": "Grupo 124",
    transform: "translate(-4492 -37.907)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_135",
    "data-name": "Caminho 135",
    d: "M6,82.229A1.23,1.23,0,0,1,7.229,81H34.273A1.23,1.23,0,0,1,35.5,82.229v6.147a2.459,2.459,0,0,1-2.459,2.459H8.459A2.459,2.459,0,0,1,6,88.376Z",
    transform: "translate(4490.918 -16.048)",
    fill: "#ffc43b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_136",
    "data-name": "Caminho 136",
    d: "M4,87.483a6.557,6.557,0,0,0,6.557,6.557H36.78A6.557,6.557,0,0,0,38.956,81.3c.007-.123.01-.246.01-.371a6.562,6.562,0,0,0-8.524-6.255,10.926,10.926,0,0,0-19.885,6.255A6.557,6.557,0,0,0,4,87.483Z",
    transform: "translate(4488 -32.093)",
    fill: "#d5f2fe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_137",
    "data-name": "Caminho 137",
    d: "M43.153,86.254A6.564,6.564,0,0,0,38.887,81.3c.007-.123.01-.246.01-.371a6.562,6.562,0,0,0-8.524-6.255,10.926,10.926,0,0,0-19.885,6.255,6.558,6.558,0,0,0-6.441,5.328,6.558,6.558,0,0,0,6.441,5.328H36.711A6.558,6.558,0,0,0,43.153,86.254Z",
    transform: "translate(4488.069 -32.093)",
    fill: "#e6f7fe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_138",
    "data-name": "Caminho 138",
    d: "M8.044,78.772a.493.493,0,0,1,.492-.492h4.285a.492.492,0,0,1,.492.492v8.163a.492.492,0,0,1-.492.492H8.536a.493.493,0,0,1-.492-.492Z",
    transform: "translate(4493.897 -20.015)",
    fill: "#e27e86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_139",
    "data-name": "Caminho 139",
    d: "M13.813,84.255a.49.49,0,0,0,.492.492H18.59a.492.492,0,0,0,.492-.492V76.093a.493.493,0,0,0-.492-.492H14.3a.492.492,0,0,0-.492.492Z",
    transform: "translate(4502.312 -23.923)",
    fill: "#b3e59e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_140",
    "data-name": "Caminho 140",
    d: "M11.774,75.971a.527.527,0,0,1,.853,0L17.3,82.447a.527.527,0,0,1-.425.836H7.528a.528.528,0,0,1-.428-.836Z",
    transform: "translate(4492.376 -23.7)",
    fill: "#e27e86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_141",
    "data-name": "Caminho 141",
    d: "M17.544,86.1a.524.524,0,0,0,.853,0l4.674-6.476a.528.528,0,0,0-.428-.836H13.3a.527.527,0,0,0-.425.836Z",
    transform: "translate(4500.79 -19.279)",
    fill: "#b3e59e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_142",
    "data-name": "Caminho 142",
    d: "M6,82.229A1.23,1.23,0,0,1,7.229,81h3.135a1.229,1.229,0,0,1,.919.413l1.36,1.527a2.448,2.448,0,0,0,1.837.826H34.273A1.23,1.23,0,0,1,35.5,85v16.9a1.23,1.23,0,0,1-1.229,1.229H7.229A1.23,1.23,0,0,1,6,101.9Z",
    transform: "translate(4490.918 -16.048)",
    fill: "#ffe07d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_143",
    "data-name": "Caminho 143",
    d: "M6,98.415c8.92-2.488,21.011-6.96,29.335-15.155V98.609a1.223,1.223,0,0,1-1.222,1.222H7.222A1.223,1.223,0,0,1,6,98.609Z",
    transform: "translate(4490.918 -12.751)",
    fill: "#ffd85b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_592",
    "data-name": "Ret\\xE2ngulo 592",
    width: 8,
    transform: "translate(4500 71)",
    fill: "#b3e59e"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportarAgendamentoTarefas);
export default __webpack_public_path__ + "static/media/importar-agendamento-tarefas.7422e2ccdca8f0c329cf57af34d56c4d.svg";
export { ForwardRef as ReactComponent };